import React, { createContext, useContext } from 'react';

type ContactDialogContextValue = {
    openContactDialog: () => void;
};

const ContactDialogContext = createContext<ContactDialogContextValue | null>(null);

export function ContactDialogProvider({
    children,
    openContactDialog,
}: {
    children: React.ReactNode;
    openContactDialog: () => void;
}) {
    return (
        <ContactDialogContext.Provider value={{ openContactDialog }}>
            {children}
        </ContactDialogContext.Provider>
    );
}

export function useOpenContactDialog(): () => void {
    const ctx = useContext(ContactDialogContext);
    return ctx?.openContactDialog ?? (() => null);
}
